/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dynamic_Ui_ClickInputs */

const en_dynamic_ui_click = /** @type {(inputs: Dynamic_Ui_ClickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click`)
};

const ar_dynamic_ui_click = /** @type {(inputs: Dynamic_Ui_ClickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انقر`)
};

const bn_dynamic_ui_click = /** @type {(inputs: Dynamic_Ui_ClickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্লিক`)
};

const de_dynamic_ui_click = /** @type {(inputs: Dynamic_Ui_ClickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klicken`)
};

const es_dynamic_ui_click = /** @type {(inputs: Dynamic_Ui_ClickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haga clic`)
};

const fr_dynamic_ui_click = /** @type {(inputs: Dynamic_Ui_ClickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliquez`)
};

const pt_dynamic_ui_click = /** @type {(inputs: Dynamic_Ui_ClickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clique`)
};

const zh_dynamic_ui_click = /** @type {(inputs: Dynamic_Ui_ClickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`单击`)
};

const tr_dynamic_ui_click = /** @type {(inputs: Dynamic_Ui_ClickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tıklayın`)
};

const ru_dynamic_ui_click = /** @type {(inputs: Dynamic_Ui_ClickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нажмите`)
};

const pl_dynamic_ui_click = /** @type {(inputs: Dynamic_Ui_ClickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kliknij`)
};

/**
* | output |
* | --- |
* | "Click" |
*
* @param {Dynamic_Ui_ClickInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const dynamic_ui_click = /** @type {((inputs?: Dynamic_Ui_ClickInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dynamic_Ui_ClickInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_dynamic_ui_click(inputs)
	if (locale === "bn") return bn_dynamic_ui_click(inputs)
	if (locale === "de") return de_dynamic_ui_click(inputs)
	if (locale === "es") return es_dynamic_ui_click(inputs)
	if (locale === "fr") return fr_dynamic_ui_click(inputs)
	if (locale === "pt") return pt_dynamic_ui_click(inputs)
	if (locale === "zh") return zh_dynamic_ui_click(inputs)
	if (locale === "tr") return tr_dynamic_ui_click(inputs)
	if (locale === "ru") return ru_dynamic_ui_click(inputs)
	if (locale === "pl") return pl_dynamic_ui_click(inputs)
	return en_dynamic_ui_click(inputs)
});